import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    minHeight: '800px',
  },
  connectContainer: {
    '& > #finicityConnectIframe': {
      position: 'relative',
      minHeight: '800px',
    },
    width: '100%',
    height: '100%',
    minHeight: '800px',
  },
}));

function FinicityConnect({
  connectUrl,
  onSuccess,
  onFail,
  onCancel,
}) {
  const classes = useStyles();

  const finicityLink = () => {
    if (!window.finicityConnect) {
      return null;
    }
    window.finicityConnect.destroy(); // eslint-disable-line
    return window.finicityConnect.launch(connectUrl, {
      selector: '#connect-container',
      overlay: 'rgba(255,255,255, 0)',
      success() {
        onSuccess();
      },
      cancel() {
        onCancel();
      },
      error() {
        onFail();
      },
      loaded() {
        // This gets called only once after the iframe has finished loading
      },
      route() {
        // This is called as the user progresses through Connect, there is a parameter for the event
      },
    });
  };

  useEffect(() => {
    finicityLink();
    return () => {
      window.finicityConnect?.destroy(); // eslint-disable-line
    };
  }, []);

  return (
    <div className={classes.root}>
      <div id="connect-container" className={classes.connectContainer} />
    </div>
  );
}

FinicityConnect.defaultProps = {
  connectUrl: '',
  onCancel: () => {},
  onSuccess: () => {},
  onFail: () => {},
};

FinicityConnect.propTypes = {
  connectUrl: PropTypes.string,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  onFail: PropTypes.func,
};

export default FinicityConnect;
